import {create} from 'zustand';

interface RumViewOnceActionsState {
  /** Action names already recorded in the current RUM view. */
  recorded: Record<string, true>;

  markRecorded: (name: string) => void;
  reset: () => void;
}

/**
 * Tracks which once-per-view actions have fired in the current RUM view so
 * per-view SLIs count a view once no matter how many panels it holds.
 */
export const useRumViewOnceActionsStore = create<RumViewOnceActionsState>()(
  set => ({
    recorded: {},

    markRecorded: name =>
      set(state => ({recorded: {...state.recorded, [name]: true}})),
    reset: () => set({recorded: {}}),
  })
);

/**
 * Returns true the first time `name` is claimed in the current RUM view and
 * false for every later call until the view resets.
 */
export function claimRumViewOnceAction(name: string): boolean {
  const store = useRumViewOnceActionsStore.getState();
  if (store.recorded[name]) {
    return false;
  }
  store.markRecorded(name);
  return true;
}

/** Starts each manual RUM view with an empty once-per-view cache. */
export function resetRumViewOnceActionsForView(): void {
  useRumViewOnceActionsStore.getState().reset();
}
